import {
  THookStateInfo,
  TSelector,
  useShallowEqualSelector,
} from '../../../redux/rootSelectors';
import { BwListUpdateState } from '../reducer';

/** список селекторов */
export const selectorBwListModal: TSelector<
  BwListUpdateState['isShowModal']
> = ({ bwListUpdateReducer }) => bwListUpdateReducer.isShowModal;

export const selectorBwListUploadType: TSelector<
  BwListUpdateState['uploadType']
> = ({ bwListUpdateReducer }) => bwListUpdateReducer.uploadType;

/** Список хуков */
export const useBwListModalInfo: THookStateInfo<
  BwListUpdateState['isShowModal']
> = () => useShallowEqualSelector(selectorBwListModal);

export const useBwListUploadTypeInfo: THookStateInfo<
  BwListUpdateState['uploadType']
> = () => useShallowEqualSelector(selectorBwListUploadType);
